module.exports = "/_next/static/images/8c2898467db12665179bf6eea4062f25-nu-icon.png";